import { SupabaseClient } from '@supabase/supabase-js';

import { Database } from '@/lib/types';

export enum ClientType {
  SERVER = 'server',
  SPA = 'spa',
}

export class SassClient {
  private client: SupabaseClient<Database>;

  // clientType is still accepted so both factories keep their call signature, but
  // nothing reads it since SassClient.logout() was removed.
  constructor(client: SupabaseClient<Database>, _clientType: ClientType) {
    this.client = client;
  }

  async loginEmail(email: string, password: string) {
    return this.client.auth.signInWithPassword({
      email: email,
      password: password,
    });
  }

  async registerEmail(email: string, password: string) {
    return this.client.auth.signUp({
      email: email,
      password: password,
      options: {},
    });
  }

  async exchangeCodeForSession(code: string) {
    return this.client.auth.exchangeCodeForSession(code);
  }

  async resendVerificationEmail(email: string) {
    return this.client.auth.resend({
      email: email,
      type: 'signup',
    });
  }

  getSupabaseClient() {
    return this.client;
  }
}
